<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" style="max-width: 50%" />
    <!-- <h1>Thank you for visiting</h1> -->
    <Balance msg="Welcome" />
  </div>
</template>

<script>
// @ is an alias to /src
import Balance from "@/components/Balance.vue";

export default {
  name: "Home",
  components: {
    Balance
  }
};
</script>
